import { render, staticRenderFns } from "./LandingButton.vue?vue&type=template&id=453d5adf&scoped=true&"
import script from "./LandingButton.vue?vue&type=script&lang=ts&"
export * from "./LandingButton.vue?vue&type=script&lang=ts&"
import style0 from "./LandingButton.vue?vue&type=style&index=0&id=453d5adf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d5adf",
  null
  
)

export default component.exports